import React from 'react';
import AshraeGuidance
  from '@avtechsoftware/react-component-library/src/components/guidance/AshraeGuidance/AshraeGuidance';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { masterDeviceListPropType } from '@avtechsoftware/react-component-library/src/types/AvtechPropTypes';
import filterSampleListOnMatchers from '@avtechsoftware/ra-javascript-utilities/src/utilities/samples/SampleUtility';
import { connect } from 'react-redux';
import ProgressSpinner
  from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import envConfig from '../../../../envConfig';
import { RaaRoles, sessionUserHasRolePrivileges } from '../../../../utility/SecurityRules';
import {
  selectActiveSubscriptionCounts, selectSessionHash,
  selectSessionInformation, sessionInformationPropType,
} from '../../../../redux/slices/sessionSlice';
import { sessionHash } from '../../../../utility/remoteServiceUtil';
import {
  channelKeyListToSensorList,
  fetchDeviceListData, selectByUuidOrMacAddress,
  selectRoomAlertDeviceList, selectSensorMap,
} from '../../../../redux/slices/deviceList/deviceListSlice';
import {
  selectAllThresholdRanges,
  selectThresholdRangeById,
} from '../../../../redux/slices/thresholdRangeSlice/thresholdRangeSlice';

class AshraeGuidanceConnected extends React.Component {
  constructor(props) {
    super(props);
    this.redirectToExploreSensorData = this.redirectToExploreSensorData.bind(this);
  }

  redirectToExploreSensorData() {
    const { history } = this.props;
    history.push('/s/sensor-data/explore');
  }

  /* istanbul ignore next */
  render() {
    const {
      masterDeviceListContext,
      thresholdRangeContext,
      latestSamples,
      sessionInformation,
      sensorMap,
    } = this.props;
    return (
      <>
        {thresholdRangeContext.findAll().length <= 0 ? (
          <div className="row d-flex justify-content-center mt-5">
            <div>
              <ProgressSpinner progressText="" />
            </div>
          </div>
        ) : (
          <AshraeGuidance
            getSensorMap={() => sensorMap}
            latestTemperatureReadings={filterSampleListOnMatchers(latestSamples, ['*_*_*_1_*_*'])}
            latestHumidityReadings={filterSampleListOnMatchers(latestSamples, ['*_*_*_2_*_*'])}
            authToken={sessionHash}
            masterDeviceList={masterDeviceListContext}
            thresholdRangeContext={thresholdRangeContext}
            temperatureScale={sessionInformation.temperatureScale}
            reportDataUrlBase={`${envConfig.apiUrl}/api/v1/device-data/device/samples/find-by-channel-keys`}
            exploreSensorDataFunc={this.redirectToExploreSensorData}
            applicationName="Room Alert Account"
            userHasAdminPrivileges={
              sessionUserHasRolePrivileges(sessionInformation.activeSubscription, [RaaRoles.ADMIN])
            }
          />
        )}
      </>
    );
  }
}

AshraeGuidanceConnected.propTypes = {
  masterDeviceListContext: masterDeviceListPropType.isRequired,
  thresholdRangeContext: PropTypes.shape({
    findAll: PropTypes.func.isRequired,
    findById: PropTypes.func.isRequired,
  }).isRequired,
  history: PropTypes.shape({ push: PropTypes.func }).isRequired,
  latestSamples: PropTypes.objectOf(PropTypes.shape(
    { t: PropTypes.number, v: PropTypes.string },
  )).isRequired,
  sessionInformation: sessionInformationPropType.isRequired,
  sensorMap: PropTypes.arrayOf(PropTypes.string).isRequired,
};

/* istanbul ignore next */
const mapStateToProps = (state) => ({
  sessionInformation: selectSessionInformation(state),
  activeSubscriptionCounts: selectActiveSubscriptionCounts(state),
  sessionHash: selectSessionHash(state),
  thresholdRangeContext: {
    findAll: () => selectAllThresholdRanges(state),
    findById: (id) => selectThresholdRangeById(state, id),
  },
  sensorMap: selectSensorMap(state),
  masterDeviceListContext: {
    deviceList: selectRoomAlertDeviceList(state),
    findAll: () => selectRoomAlertDeviceList(state),
    refresh: () => fetchDeviceListData(),
    channelKeyListToSensorList: (channelKeyList) => channelKeyListToSensorList(
      state, channelKeyList,
    ),
    findByUUID: (id) => selectByUuidOrMacAddress(state, id),
    getSensorMap: () => selectSensorMap(state),
    getFullDeviceList: () => selectRoomAlertDeviceList(state),
    channelKeyList: (channelKeyList) => channelKeyListToSensorList(channelKeyList),
  },
});

export { AshraeGuidanceConnected };

export default withRouter(
  connect(mapStateToProps)(AshraeGuidanceConnected),
);
